@if (isClickable()) {
  <!--
    This is a workaround to prevent the click event ([routerLink]) from bubbling up to the parent element.
    Specifically, when used on a provider listing card (matches/directory) which is clickable,
    we don't want the click event to trigger the profile view.
  -->
  <a [routerLink]="[addInsuranceRoute]" (click)="$event.stopPropagation()">
    <ng-container *ngTemplateOutlet="coverageBadge"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="coverageBadge"></ng-container>
}

<ng-template #coverageBadge>
  <div
    class="coverage-badge"
    [ngClass]="badgeType()"
    [class.skeleton-loader]="isUpdating()"
  >
    @if (hasImage()) {
      <div class="coverage-badge-icon">
        @if (badgeType() === coverageBadgeType.IN_NETWORK) {
          <img src="/assets/check_gear.svg" alt="Check Gear" />
        }
        @else if (badgeType() === coverageBadgeType.COVERAGE_UNVERIFIED) {
          <iris-icon
            [size]="iconSizes.MD"
            name="info"
            [color]="iconColors.BRAND1"
          ></iris-icon> 
        }
        @else {
          <iris-icon
            [size]="iconSizes.MD"
            name="info"
            [color]="iconColors.DANGER"
          ></iris-icon> 
        }
      </div>
    }
    <div
      class="coverage-badge-text"
      data-test="coverage-badge-text"
    >{{ badgeText() }}</div>
  </div>
</ng-template>
